// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1T_ug","head":"ProcedureTableInfo_head__C1fdS"};